import { apiUrl, apiUrlV2 } from "../constants/apiUrl"
import rollbarLogger from "../utilities/rollbarLogger"

const initialState = {
  dealersListFetching: false,
  savedDealers: []
}

const createDealersListSlice = (set, get) => ({
  ...initialState,
  fetchListDealers: async() => {
    set((state) => ({ dealersListFetching: true}))

    try {
      const response = await fetch(
        `${apiUrlV2}/dealers/my_dealers`,
        {headers: get().requestHeaders}
      )
      if (response.status === 200) {
        const data = await response.json()

        if(get().user) {
          set((state) => ({
            savedDealers: data.data,
            dealersListFetching: false,
          }))
        }
      }
    } catch (err) {
      get().logError('There was an error fetching the list dealers.', err)
    }
  },
  createListDealer: async (dealerId) => {
    try {
      await fetch(
        `${apiUrlV2}/list_dealers`, {
          method: 'POST',
          headers: get().requestHeaders,
          body: JSON.stringify({ list_dealer: { dealer_id: dealerId } }),
        }
      )
      get().fetchListDealers()
    } catch (err) {
      get().logError('Dealer was unable to be saved.', err)
    }
  },
  removeListDealer: async (listDealerId) => {
    try {
      await fetch(
        `${apiUrlV2}/list_dealers/${listDealerId}`, {
          method: 'DELETE',
          headers: { 'Authorization': get().requestHeaders['Authorization'] },
        }
      )
      get().fetchListDealers()
    } catch (err) {
      get().logError('Dealer was unable to be removed.', err)
    }
  },
  updateListDealer: async (position, dealerId) => {
    try {
      await fetch(
        `${apiUrlV2}/list_dealers/${dealerId}`, {
          method: 'PUT',
          headers: { 'Authorization': get().requestHeaders['Authorization'], 'Content-Type': 'application/json'},
          body: JSON.stringify({
            list_dealer: { dealer_id: dealerId, position: position }
          })
        }
      )
      get().fetchListDealers()
    } catch (err) {
      get().logError('Dealer was unable to be updated.', err)
    }
  },
  removeAllListDealers: async () => {
    try {
      await fetch(
        `${apiUrlV2}/list_dealers/delete_all`, {
          method: 'DELETE',
          headers: { 'Authorization': get().requestHeaders['Authorization'] },
        }
      )
      get().fetchListDealers()
    } catch (err) {
      get().logError('Dealers were unable to be removed.', err)
    }
  }
})

export default createDealersListSlice